import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { subscribeNewsletter } from '../services/api';
import type { NewsletterSubscriptionError } from '../types';

/**
 * Custom hook for newsletter subscription
 * @returns Mutation object with subscribe function and state
 */
export function useNewsletterSubscription() {
  return useMutation({
    mutationFn: (email: string) => subscribeNewsletter(email),
    onSuccess: () => {
      toast.success('Successfully subscribed to newsletter!', {
        description:
          "Thank you for subscribing. You'll receive our latest updates soon.",
        duration: 5000,
      });
    },
    onError: (error: NewsletterSubscriptionError) => {
      toast.error('Failed to subscribe to newsletter', {
        description: error.message || 'Please try again later.',
        duration: 5000,
      });
    },
  });
}
